import { Component, ViewChild, ElementRef } from '@angular/core';
var LyHeaderPagination = /** @class */ (function () {
    function LyHeaderPagination(elementRef) {
        this.elementRef = elementRef;
        this._with = 150;
        this._positionX = 0;
        this.traslateWidth = 100;
    }
    LyHeaderPagination.prototype.updateAll = function () {
        this._with = this.elementContainer.clientWidth;
        this._withHost = this.elementRef.nativeElement.clientWidth;
        /*console.log(this.elementContainer.clientWidth);*/
        /*console.log(
              'this._positionX',
              this._positionX,
              'this._withHost',
              this._withHost,
              'this._with',
              this._with,
            );*/
    };
    LyHeaderPagination.prototype.ngAfterContentInit = function () {
        this.elementContainer = this.elementRef.nativeElement.querySelector('._container_items');
        this._withHost = this.elementRef.nativeElement.clientWidth;
        /*console.log(this.elementContainer.clientWidth);*/
        this._with = this.elementContainer.clientWidth;
    };
    LyHeaderPagination.prototype._to_left = function () {
        this.updateAll();
        this._positionX = this._positionX + this.traslateWidth;
        if (this._positionX < 0) {
            this.elementContainer.setAttribute('style', "\n      left: " + this._positionX + "px;\n      ");
        }
        else {
            this._positionX = 0;
            this.elementContainer.setAttribute('style', "\n      left: " + 0 + ";\n      ");
        }
    };
    LyHeaderPagination.prototype._to_right = function () {
        this.updateAll();
        this._positionX = this._positionX - this.traslateWidth;
        if (-(this._positionX) + this._withHost <= this._with) {
            this.elementContainer.setAttribute('style', "\n      left: " + this._positionX + "px;\n      ");
        }
        else {
            this._positionX = -(this._with) + this._withHost;
            this.elementContainer.setAttribute('style', "\n      left: " + (-(this._with) + this._withHost) + "px;\n      ");
        }
    };
    LyHeaderPagination.decorators = [
        { type: Component, args: [{
                    selector: 'ly-header-pagination',
                    template: "<div lyRippleRadius=\"containerSize\" lyRipple lyRippleCentered *ngIf=\"_positionX != 0\" class=\"_op_left\" (click)=\"_to_left()\"> <span> <svg viewBox=\"0 0 24 24\" style=\"display: inline-block; height: 24px; width: 24px; user-select: none; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\"><path d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"></path></svg> </span> </div> <div class=\"kfjddxm\" tabindex=\"0\"></div> <div class=\"_container\"> <div class=\"_container_items\" #elementContainer> <ng-content></ng-content> </div> </div> <div class=\"_op_right\"  lyRippleRadius=\"containerSize\" lyRipple lyRippleCentered *ngIf=\"_with > (-(_positionX) + _withHost)\" (click)=\"_to_right()\"> <span> <svg viewBox=\"0 0 24 24\" style=\"display: inline-block; height: 24px; width: 24px; user-select: none; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\"><path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"></path></svg> </span> </div> ",
                    styles: [":host{position:absolute;width:100%;height:100%;display:inline-block;top:0;bottom:0;margin:auto;line-height:normal}._container{position:absolute;height:inherit;width:100%;overflow:hidden;top:0;left:0}._container_items{display:inline-flex;position:absolute;transition:450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;left:0;height:100%}._op_left,._op_right{position:absolute;display:inline-block;height:inherit;width:24px;height:24px;z-index:99;top:0;bottom:0;margin:auto 0;cursor:pointer;color:rgba(245,0,87,0.63)}._op_left:hover,._op_right:hover{color:#f50057}._op_left span,._op_right span{fill:currentColor;position:absolute;top:0}._op_right{right:0}._op_left{left:0} "],
                    host: {
                        '(mouseenter)': 'updateAll()',
                    },
                },] },
    ];
    /** @nocollapse */
    LyHeaderPagination.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    LyHeaderPagination.propDecorators = {
        "_elementContainer": [{ type: ViewChild, args: ['elementContainer',] },],
    };
    return LyHeaderPagination;
}());
export { LyHeaderPagination };
//# sourceMappingURL=header-pagination.component.js.map